"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormInlineTableField = void 0;
const inline_table_field_1 = require("../../../components/inline-table-field/inline-table-field");
const form_field_1 = require("./form-field");
exports.FormInlineTableField = (0, form_field_1.formFieldFactory)(inline_table_field_1.InlineTableField);
//# sourceMappingURL=form-inline-table-field.js.map